// src/lib/page-title.ts
//
// Título da aba: "<página> · <marca>". A marca vem do branding
// (`useBrandingIdentity`); cada tela informa o próprio título enquanto montada.
import { useEffect } from "react";

let brandTitle = typeof document === "undefined" ? "Education" : document.title;
let pageTitle: string | null = null;

function apply() {
  document.title = pageTitle ? `${pageTitle} · ${brandTitle}` : brandTitle;
}

export function setBrandTitle(title: string) {
  brandTitle = title;
  apply();
}

export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    if (!title) return;
    pageTitle = title;
    apply();
    return () => {
      if (pageTitle !== title) return;
      pageTitle = null;
      apply();
    };
  }, [title]);
}
